// DemReconTrendChart.jsx
import { useEffect, useState } from 'react';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';

export const DemReconTrendChart = ({ startPeriod, endPeriod, periodicity, prodIds }) => {
  const rsrc = useRsrc();
  const [data, setData] = useState();

  useEffect(() => {
    const reqParam = { startPeriod, endPeriod, periodicity, prodIds };
    rsrc.data('gtn', 'RECON_TREND_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });
  }, [startPeriod, endPeriod, periodicity, prodIds]);

  if (!data) return null;

  return (
    <CartesianChart
      data={data}
      legend="top"
      yLabel="Discrepancy Dollars"
      stacked
    />
  );
};
